export type TransferIdentityCheck = {
  id: string; quantity: number; damaged: number;
  serial_scan: string; lot_scan: string; expiry_scan: string;
};
export type TransferIdentityFields = {
  identityChecks?: TransferIdentityCheck[];
  itemScan?: string; sourceScan?: string; locationScan?: string; holdingScan?: string;
};
export type TransferIdentity = {
  id: string; serial: string | null; lot: string | null; expiry: string | null;
  unit_cost: number; currency: string; source: number; transit: number; held: number;
  shipped: number; received: number; damaged: number; returned: number; lost: number;
  restocked: number; disposed: number;
};
export function transferIdentityFields(raw: Record<string, unknown>, action: string): TransferIdentityFields {
  const keys = ['identity_checks', 'identity_checked', 'item_scan', 'source_scan', 'location_scan', 'holding_scan'];
  if (!keys.some(k => raw[k] !== undefined)) return {};
  if (!['ship', 'receive', 'return', 'loss', 'restock', 'dispose'].includes(action)) throw new Error('Identity checks belong to a physical transfer movement.');
  if (raw.identity_checked !== true) throw new Error('Confirm the physical count and condition of the selected identities.');
  const rows = raw.identity_checks;
  if (!Array.isArray(rows) || !rows.length || rows.length > 200) throw new Error('Select between 1 and 200 exact serials or batches per line.');
  const seen = new Set<string>();
  const identityChecks = rows.map(r => {
    if (!r || typeof r !== 'object' || Array.isArray(r) || Object.keys(r).some(k => !['id', 'quantity', 'damaged', 'serial_scan', 'lot_scan', 'expiry_scan'].includes(k))
      || typeof r.id !== 'string' || !r.id.length || r.id.length > 100 || seen.has(r.id)
      || !Number.isSafeInteger(r.quantity) || r.quantity < 0 || r.quantity > 1000000
      || !Number.isSafeInteger(r.damaged ?? 0) || (r.damaged ?? 0) < 0 || (r.damaged ?? 0) > 1000000
      || r.quantity + (r.damaged ?? 0) < 1 || action !== 'receive' && (r.damaged ?? 0) !== 0
      || ['serial_scan', 'lot_scan', 'expiry_scan'].some(k => typeof r[k] !== 'string' || r[k].length > 200)) throw new Error('Check each identity once with whole quantities, serial, batch and expiry scans.');
    seen.add(r.id);
    return { id: r.id, quantity: r.quantity, damaged: r.damaged ?? 0, serial_scan: r.serial_scan, lot_scan: r.lot_scan, expiry_scan: r.expiry_scan } as TransferIdentityCheck;
  });
  const scan = (key: string) => {
    const value = raw[key] ?? '';
    if (typeof value !== 'string' || value.length > 200) throw new Error('Use a valid product or bin scan.');
    return value.trim();
  };
  return { identityChecks, itemScan: scan('item_scan'), sourceScan: scan('source_scan'), locationScan: scan('location_scan'), holdingScan: scan('holding_scan') };
}
